import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Spinner from "../Loader/Spinner";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import "react-google-flight-datepicker/dist/main.css";
import makeAnimated from "react-select/animated";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css";
import { format } from "date-fns";
import AdminCards from "../Cards/AdminCards";

import { Button } from "@mui/material";
import FundCards from "../Cards/FundCards";
import SchoolCards from "../Cards/SchoolCards";
import AnweshaCards from "../Cards/AnweshaCards";

const AdminCharts = ({ data1, title, role, userData }) => {
  const { t } = useTranslation();
  const handleClick = (e) => {
    i18next.changeLanguage(e.target.value);
  };

  const [isLoading, setIsLoading] = useState(true);
  const [check, setCheck] = useState(false);
  const [selectedHostels, setSelectedHostels] = useState([]);
  const [dateRange, setDateRange] = useState({
    startDate: "",
    endDate: "",
  });

  const [activeFund, setActiveFund] = useState(false);
  const [activeAsset, setActiveAsset] = useState(false);
  const [activeSchool, setActiveSchool] = useState(true);
  const [activeAnwesha, setActiveAnwesha] = useState(false);
  const [dashboard, setDashboard] = useState("School-Hostel");

  const handleDashboardChange = (e) => {
    if (e.target.value === "Fund") {
      setDashboard("Fund");
      setActiveFund(true);
      setActiveAsset(false);
      setActiveSchool(false);
      setActiveAnwesha(false);
    } else if (e.target.value === "Asset") {
      setDashboard("Asset");
      setActiveFund(false);
      setActiveAsset(true);
      setActiveSchool(false);
      setActiveAnwesha(false);
    } else if (e.target.value === "School-Hostel") {
      setDashboard("School-Hostel");
      setActiveFund(false);
      setActiveAsset(false);
      setActiveSchool(true);
      setActiveAnwesha(false);
    } else if (e.target.value === "Anwesha") {
      setDashboard("Anwesha");
      setActiveFund(false);
      setActiveAsset(false);
      setActiveSchool(false);
      setActiveAnwesha(true);
    }
  };

  const animatedComponents = makeAnimated();

  const currentDate = new Date();

  const currentStartDate = new Date(currentDate.getFullYear(), 3, 1);
  const sDate = format(currentStartDate, "yyyy-MM-dd");

  const nextYear = currentDate.getFullYear() + 1;
  const currentEndDate = new Date(nextYear, 2, 31);
  const eDate = format(currentEndDate, "yyyy-MM-dd");

  let data = {
    toggle: check,
    start_date: dateRange.startDate === "" ? sDate : dateRange.startDate,
    end_date: dateRange.endDate === "" ? eDate : dateRange.endDate,
  };

  return (
    <div className="row">
      <div className="col-12 d-flex row justify-content-start m-0">
        <div className="my-4 col-6 d-flex justify-content-between align-items-center">
          <h3 className="my-4" style={{ color: "#0b3c85" }}>
            {t(dashboard)}
            {" "}
            {t("Dashboard")}
          </h3>
        </div>
        <div className="my-4 col-6 d-flex justify-content-end align-items-center">
          <Button
            className="col-3 mx-2"
            style={{ boxShadow: "0 0 1px gray" }}
            variant={activeSchool === false ? "outlined" : "contained"}
            value="School-Hostel"
            onClick={handleDashboardChange}
          >
            {t("School-Hostel")}
          </Button>
          {role === 8 || role === 11 || role === 12 || role === 13 ? (
            <Button
              className="col-3 mx-2"
              style={{ boxShadow: "0 0 1px gray" }}
              variant={activeAnwesha === false ? "outlined" : "contained"}
              value="Anwesha"
              onClick={handleDashboardChange}
            >
              {t("Anwesha")}
            </Button>
          ) : (
            ""
          )}
          <Button
            className="col-3 mx-2"
            style={{ boxShadow: "0 0 1px gray" }}
            variant={activeAsset === false ? "outlined" : "contained"}
            value="Asset"
            onClick={handleDashboardChange}
          >
            {t("Asset")}
          </Button>
          {role === 6 ||
          role === 8 ||
          role === 11 ||
          role === 12 ||
          role === 13 ? (
            <Button
              className="col-3 mx-2"
              style={{ boxShadow: "0 0 1px gray" }}
              variant={activeFund === false ? "outlined" : "contained"}
              value="Fund"
              onClick={handleDashboardChange}
            >
              {t("Fund")}
            </Button>
          ) : (
            ""
          )}
        </div>
      </div>

      {dashboard === "Fund" ? (
        <FundCards role={role} userData={userData.data} dashboard={dashboard} />
      ) : dashboard === "Asset" ? (
        <AdminCards
          role={role}
          userData={userData.data}
          dashboard={dashboard}
        />
      ) : dashboard === "Anwesha" ? (
        <AnweshaCards
          role={role}
          userData={userData.data}
          dashboard={dashboard}
        />
      ) : (
        <SchoolCards
          role={role}
          userData={userData.data}
          dashboard={dashboard}
        />
      )}
    </div>
  );
};

export default AdminCharts;
